@if (hasAny()) {
  <div class="attribute-tag-chips">
    @for (tag of visible(); track $index) {
      <span
        class="attribute-tag-pill"
        [matTooltip]="tag.truncated ? tag.full : ''"
        matTooltipClass="app-tooltip"
        matTooltipPosition="above"
        ><span class="attribute-tag-pill-name">{{ tag.display }}</span></span
      >
    }
    @if (hiddenCount() > 0) {
      <span
        class="attribute-tag-pill attribute-tag-pill--more"
        [matTooltip]="tooltipText()"
        matTooltipClass="app-tooltip"
        matTooltipPosition="above"
        ><span class="attribute-tag-pill-name">+{{ hiddenCount() }}</span></span
      >
    }
  </div>
}
